var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLockedOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_locked_off") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_locked_off",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F2F2F2",
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-11",
    fill: "#A3AFB7",
    x: 4,
    y: 7,
    width: 10,
    height: 8,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8571429,7.66666667 L10.4285714,7.66666667 L10.4285714,5.66824632 C10.4285714,4.93077903 9.78881896,4.33333333 9,4.33333333 C8.21306492,4.33333333 7.57142857,4.9320839 7.57142857,5.66824632 L7.57142857,7.66666667 L6.14285714,7.66666667 L6.14285714,5.66824632 C6.14285714,4.19461457 7.4252544,3 9,3 C10.5779564,3 11.8571429,4.19454788 11.8571429,5.66824632 L11.8571429,7.66666667 L11.8571429,7.66666667 Z",
    id: "Path",
    fill: "#A3AFB7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLockedOff);
export default __webpack_public_path__ + "static/media/icon_locked_off.d26d79fba23a51845346c6b1cb246992.svg";
export { ForwardRef as ReactComponent };